@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

$size: 'lg' 2em,
  'md' 24px;

.NumberCircle {
  @extend %font-family-primary;

  border-radius: 50%;
  color: $color-white;
  display: flex;
  align-items: center;
  justify-content: center;

  &.magenta {
    background: $color-ace-constant;
    text-shadow:
      -1px -1px 0 $color-ace-constant,
      1px -1px 0 $color-ace-constant,
      -1px 1px 0 $color-ace-constant,
      1px 1px 0 $color-ace-constant;
  }

  &.green {
    background: $color-primary-green;
    text-shadow:
      -1px -1px 0 $color-primary-green,
      1px -1px 0 $color-primary-green,
      -1px 1px 0 $color-primary-green,
      1px 1px 0 $color-primary-green;
  }

  &.orange {
    background: $color-warning-orange;
    text-shadow:
      -1px -1px 0 $color-warning-orange,
      1px -1px 0 $color-warning-orange,
      -1px 1px 0 $color-warning-orange,
      1px 1px 0 $color-warning-orange;
  }

  &.red {
    background: $color-primary-red;
    text-shadow:
      -1px -1px 0 $color-primary-red,
      1px -1px 0 $color-primary-red,
      -1px 1px 0 $color-primary-red,
      1px 1px 0 $color-primary-red;
  }

  &.grey {
    background: $color-grey-B;
    text-shadow:
      -1px -1px 0 $color-grey-B,
      1px -1px 0 $color-grey-B,
      -1px 1px 0 $color-grey-B,
      1px 1px 0 $color-grey-B;
  }

  &.purple {
    background: $color-primary-purple;
    text-shadow:
      -1px -1px 0 $color-primary-purple,
      1px -1px 0 $color-primary-purple,
      -1px 1px 0 $color-primary-purple,
      1px 1px 0 $color-primary-purple;
  }

  &.blue {
    background: $color-action-border-selected;
    text-shadow:
      -1px -1px 0 $color-action-border-selected,
      1px -1px 0 $color-action-border-selected,
      -1px 1px 0 $color-action-border-selected,
      1px 1px 0 $color-action-border-selected;
  }

  &.success {
    background-color: $color-alert-green-border;
    text-shadow:
      -1px -1px 0 $color-alert-green-border,
      1px -1px 0 $color-alert-green-border,
      -1px 1px 0 $color-alert-green-border,
      1px 1px 0 $color-alert-green-border;
  }

  &.disabled {
    background-color: $theme-progress-flow-background-color;
  }

  @each $size,
    $circle-size in $size {
    &.#{$size} {
      height: $circle-size;
      width: $circle-size;
    }
  }
}
